import { FormattedMessage } from "react-intl";

import { formatArticleDate } from "../../helpers/dateHelper";

import AuthorThumbnail from "../authorThumbnail/authorThumbnail";
import Tag from "../../components/tag/tag";
import { CommentSVG, ShareSVG } from "../../svg";
import { buildInternalPath } from "../../helpers/URLHelpers";

import styles from "./articleDetail.module.scss";
import RouterLink from "../link/RouterLink";

function ArticleDetail({
  headline,
  lead,
  authors,
  date,
  category,
  article_type,
  enable_comments,
  comment_count,
  enable_social_sharing,
}) {
  return (
    <div className={styles.articleDetail}>
      <div className={styles.tagRow}>
        {category ? (
          <RouterLink to={buildInternalPath(category.slug)}>
            <Tag label={category.content.title} />
          </RouterLink>
        ) : null}
        {article_type ? (
          <RouterLink to={buildInternalPath(article_type.slug)}>
            <Tag label={article_type.content.title} />
          </RouterLink>
        ) : null}
        {date ? (
          <span className={styles.date}>{formatArticleDate(date)}</span>
        ) : null}
      </div>
      {headline ? <h1 className={styles.headline}>{headline}</h1> : null}
      {lead ? <h2 className={styles.leadtext}>{lead}</h2> : null}
      <div className={styles.authorBar}>
        <div className={styles.authorsContainer}>
          {authors
            ? authors.map((a) => (
                <AuthorThumbnail
                  key={a.uuid}
                  slug={a.slug}
                  story_link_uuid={a.uuid}
                  name={a.name}
                  image={a.headshot}
                />
              ))
            : null}
        </div>
        {enable_comments || enable_social_sharing ? (
          <div className={styles.actions}>
            {enable_social_sharing ? (
              <button
                className={`limit-visibility hidden flex-center-children ${styles.actionitem} ${styles.shareSvg}`}
              >
                <span>
                  <FormattedMessage id="component.articledetail.share" />
                </span>
                <ShareSVG />
              </button>
            ) : null}
            {enable_comments ? (
              <button
                className={`limit-visibility hidden flex-center-children ${styles.actionitem}`}
              >
                {comment_count}
                <CommentSVG />
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
      <hr className={styles.hr} />
    </div>
  );
}

export default ArticleDetail;
